export default {
    // Navbar Section
    navbar_home: "الرئيسية",
    navbar_services: "الخدمات",
    navbar_blog: "المدونة",
    navbar_about: "من نحن",
    navbar_contact: "اتصل بنا",
    navbar_membership: "انضم الآن",


    // Home Screen (Hero Section)
    hero_title: `ابدأ <span class="with">رحلتك</span> مع <span class="with">HarashFit</span> `,
    hero_description: "تعتمد جميع البرامج على أسس علمية، ومخصصة بالكامل، ويتم تقديمها شخصيًا من قبل المدرب بدر الحرش.",
    stat_1: "عملاء",
    stat_2: "سنة من التميز",
    view_certifications: "عرض الشهادات",

    // Home Screen (Services Section)
    services_heading_small: "خدماتنا",
    services_heading_big: `أفضل الخدمات لحياة <span class="highlight">أكثر <br> نشاطًا</span> وصحة`,
    learn_more: "اعرف المزيد",

    // Home Screen (Latest Articles Section)
    latest_articles_title: `أحدث <span class="thin">المقالات</span>`,
    latest_articles_view_more: "عرض المزيد",
    latest_articles_read_more: "اقرأ المزيد →",

    // Certifications Screen (Certifications Section)
    certifications_section: {
        title: "الشهادات",
        cert_1_date: "انتهاء الصلاحية: 26/09/2026",
        cert_1_desc: "شهادة تؤهلك لتقديم برامج تدريب شخصية باحترافية دولية (NASM).",

        cert_2_date: "تم الإنجاز: 02/01/2025",
        cert_2_desc: "تخصص احترافي في بناء الأجسام باستخدام أسس علمية حديثة.",

        cert_3_date: "تم الإنجاز: 16/01/2025",
        cert_3_desc: "تدريب النساء وفق احتياجاتهن البدنية والهرمونية.",

        cert_4_date: "تم الإنجاز: 18/01/2025",
        cert_4_desc: "برامج مدروسة وآمنة لفقدان الوزن بدعم علمي.",

        cert_5_date: "تم الإنجاز: 08/10/2024",
        cert_5_desc: "تنمية الصلابة الذهنية والانضباط الذاتي في التدريب.",
    },



    // Services Screen (Services Section)
    services_hero_title: "الخدمات",
    services_hero_text: `حوّل <span class="red">جسمك</span> بأفضل <span class="red">الخدمات</span> الممكنة!`,

    // Services Screen (Services Our Services Section)
    our_services_heading_small: "خدماتنا",
    our_services_heading_big: `أفضل الخدمات لحياة <span class="highlight">أكثر <br />نشاطًا</span> وصحة`,
    our_services_description: "اكتشف خدمات مصممة خصيصًا لدعم أهدافك والارتقاء بأسلوب حياتك.",
    our_services_view_more: "عرض المزيد",
    our_services_view_less: "عرض أقل",
    our_services_learn_more: "اعرف المزيد",

    // Services Screen (Offer Section)
    stats_satisfied: "<span class='highlight'>عميل</span> راضٍ",
    stats_trainer: "<span class='highlight'>مدرب</span> محترف",
    offer_heading: "خصومات <span class='highlight'>مميزة</span> و <br /><span class='highlight'>عروض</span>",
    offer_list: [
        {
            icon: "🔥",
            title: "خصم العائلة",
            description: "تمرّن مع أفراد عائلتك واحصلوا على خصم خاص عند الاشتراك معًا لشخصين أو أكثر.",
        },
        {
            icon: "🎓",
            title: "خصم الطلاب",
            description: "هل أنت طالب؟ استمتع بعروض تدريب مخفضة عند إبراز بطاقة الطالب الخاصة بك.",
        },
        {
            icon: "🆕",
            title: "عرض العضو الجديد",
            description: "أول مرة معنا؟ نُقدّم لك خصمًا حصريًا عند اشتراكك الأول. ابدأ رحلتك الرياضية بقوة!",
        },
    ],


    // Services Screen (Memberships Section)
    membership_heading_small: "خطط الاشتراك",
    membership_heading_big: `وصول <span class="highlight">غير محدود</span> إلى اللياقة <br /><span class="highlight">التي تريدها</span>!`,
    membership_order_now: "اشترك الآن",
    view_all_plans: "عرض جميع الباقات",

    // Plans Screen (Plans Views Section)

    plans_view_plans_heading: "خطط الاشتراك",
    plans_view_plans_subheading: "اختر الخطة المناسبة لهدفك",
    plans_view_monthly: "شهري",
    plans_view_yearly: "سنوي",
    plans_view_one_time: "لمرة واحدة",
    plans_view_most_popular: "الأكثر شهرة",
    plans_view_order_now: "اطلب الآن",

    // Service Details Screen (Service Details Section)
    service_details_subtitle: "احرق الدهون وابدأ عادات صحية!",
    service_details_benefits_title: "فوائد هذا البرنامج",
    service_details_operating_hours: "ساعات العمل",
    service_details_all_services: "كل الخدمات",
    service_details_membership_join: "الانضمام للاشتراك",
    service_details_join_name: "الاسم",
    service_details_join_email: "البريد الإلكتروني",
    service_details_join_phone: "رقم الهاتف",
    service_details_join_plan: "خطة الاشتراك",
    service_details_join_plan_basic: "أساسي",
    service_details_join_plan_premium: "مميز",
    service_details_join_submit: "انضم الآن",



    // Blog Screen (Blog Section)
    blog_hero_title: "المدونة",
    blog_hero_text: `احصل على المعرفة، احصل على <span class="red">النتائج</span> – أفضل المقالات لأقصى <span class="red">أداء!</span>`,

    // Blogs Section (Blog Section)
    blogs_title_small: "المدونة",
    blogs_title_big: `احصل على <span class="highlight">المعرفة</span>، وحقق النتائج – كل شيء هنا!`,
    blogs_read_more: "اقرأ المزيد →",

    // Blog Post Screen (Blog Post Details Section)
    post_detail_why_title: "🔥 لماذا يعتبر {keyword} فعالًا؟",
    post_detail_tips_title: "💡 نصائح لتحقيق أفضل النتائج",
    post_detail_note: "🔥 جاهز لحرق الدهون في 30 دقيقة فقط؟ جرّب هذه التمارين الآن!",
    post_detail_sidebar_hours_title: "ساعات العمل",
    post_detail_sidebar_hours_1: "السبت - الأربعاء : 08.00 - 17.00",
    post_detail_sidebar_hours_2: "الخميس : 08.00 - 14.00",
    post_detail_sidebar_hours_3: "الجمعة : مغلق",
    post_detail_sidebar_related: "منشورات ذات صلة",

    // Blog Post Screen (Blog Post Question Section)
    contact_us_small: "اتصل بنا",
    contact_us_big: 'هل لا زلت <span class="highlight">تملك</span> أسئلة؟',
    contact_phone: "رقم الهاتف",
    contact_email: "البريد الإلكتروني",

    // About Screen (About Section)
    about_title: "من نحن",
    about_subtitle: 'حوّل <span class="red">جسدك</span> وارتقِ بـ<span class="red">حياتك!</span>',

    // About Screen (About Wcu Section)
    wcu_title: "لماذا <span class='highlight'>تختارني؟</span>",
    wcu_card_1_title: "<span class='highlight'>ألتزم</span> بتحقيق النتائج",
    wcu_card_1_desc: "لا أقدّم وعودًا فقط، بل أعمل معك لتحقيق نتائج واضحة وواقعية حسب هدفك.",
    wcu_card_2_title: "مدرب <span class='highlight'>محترف ومعتمد</span>",
    wcu_card_2_desc: "كمدرب شخصي معتمد، أضع خبرتي في خدمتك لتصل إلى أفضل نسخة من نفسك.",
    wcu_card_3_title: "برامج <span class='highlight'>تناسب مستواك</span>",
    wcu_card_3_desc: "سواء كنت مبتدئًا أو متقدّمًا، سأصمّم لك برنامجًا تدريبيًا يتناسب مع قدراتك ويطوّرك.",


    // About Screen (About Certificates Section)
    certifications_heading: "شهاداتي واعتماداتي",
    certifications_text: "كمُدرّب معتمد، حصلت على عدد من الشهادات الدولية من NASM وغيرها، مما يضمن لك جودة التدريب ونتائج آمنة وفعالة.",
    view_all_certifications: "عرض جميع الشهادات",

    // About Screen (About Details Section)
    about_detail_title_small: "من نحن",
    about_detail_title_big: "ابتكار يركز على <span class='highlight'>راحتك</span>",
    about_detail_paragraph: "بخبرة عملية تمتد لسنوات كمدرب شخصي معتمد (CPT)، أُقدّم برامج متخصصة في إنقاص الوزن، بناء الاجسام، واللياقة الوظيفية. رسالتي هي تمكين الأفراد من تحقيق نتائج مستدامة من خلال خطط تدريب مصممة خصيصًا لتناسب أهدافهم ونمط حياتهم. الأمر لا يقتصر على التمارين فحسب، بل يتعلق ببناء نسخة أقوى، أكثر صحة وثقة من نفسك.",
    about_detail_stat_1: "سنة من التميز",
    about_detail_stat_2: "أعضاء",
    about_detail_stat_3: "حصة أسبوعية",
    about_detail_stat_4: "مدرب خبير",
    about_detail_feature_1: "مدرب محترف",
    about_detail_feature_2: "إرشادات غذائية",
    about_detail_feature_3: "عضوية مميزة",
    about_detail_feature_4: "تتبع التقدم",
    about_detail_feature_5: "دعم مجتمعي",
    about_detail_feature_6: "مستوى متقدم",

    // Contact Screen (Contact Section)
    contact_hero_title: "اتصل بنا",
    contact_hero_paragraph: "نحن جاهزون لمساعدتك وفق <span class='red'>مبادئ اللياقة!</span>",

    // Contact Screen (Contact Info Section)
    contact_info_location_title: "الموقع",
    contact_info_location_name: "HarashFit",
    contact_info_location_address: "تلاع العلي, عمان, الأردن",

    contact_info_hours_title: "ساعات العمل",
    contact_info_hours_weekdays: "السبت - الأربعاء : 08:00AM - 5:00PM",
    contact_info_hours_thursday: "الخميس : 08:00AM - 2:00PM",
    contact_info_hours_friday: "الجمعة : مغلق",

    contact_info_contact_title: "اتصل بنا",

    contact_info_phone: "+962 7 9060 6181 :رقم الهاتف",
    contact_info_email: "info{'@'}harashfit.com :البريد الإلكتروني",

    contact_info_connect_title: "تواصل معنا",

    // Contact Screen (Contact Send Section)
    contact_form_title: "ابقَ على تواصل",
    contact_form_name: "الاسم الكامل",
    contact_form_email: "البريد الإلكتروني",
    contact_form_phone: "رقم الهاتف",
    contact_form_message: "الرسالة",
    contact_form_send: "إرسال",

    // Footer Section
    footer_description: "مدرب مستقل للياقة وكمال الأجسام — يُمكّن العملاء من خلال تدريب مخصص والتزام حقيقي.",
    footer_contact_us: "اتصل بنا",
    footer_phone: "+962 7 9060 6181 :رقم الهاتف",
    footer_email: "info{'@'}harashfit.com :البريد الإلكتروني",
    footer_links_title: "روابط سريعة",
    footer_link_services: "الخدمات",
    footer_link_blog: "أرشيف المقالات",
    footer_link_about: "من نحن",
    footer_link_team: "تواصل معنا",
    footer_location_title: "الموقع",
    footer_location_address: "تلاع العلي, عمان, الأردن",
    footer_hours_title: "ساعات العمل",
    footer_hours_1: "السبت - الأربعاء : 08.00 - 17.00",
    footer_hours_2: "الخميس : 08.00 - 14.00",
    footer_hours_3: "الجمعة : مغلق",
    footer_privacy: "سياسة الخصوصية",
    footer_terms: "الشروط والأحكام",
    footer_cookies: "سياسة ملفات تعريف الارتباط",
    footer_impressum: "الإشعار القانوني",
    footer_rights: "جميع الحقوق محفوظة.",

    // Whatsapp Section
    whatsapp_section_tooltip: "هل تحتاج مساعدة؟",
    whatsapp_section_message: "مرحبًا، أريد الاستفسار عن خدماتكم",

    "cookie": {
        "message": "نستخدم ملفات تعريف الارتباط لتحسين تجربتك.",
        "learn_more": "اعرف المزيد",
        "accept": "موافقة",
        "reject": "رفض"
    }
};
